module.exports = __webpack_public_path__ + "static/media/AMERICAN FLAG BOX.6eb82c2f.png";